import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CircleMinusIcon = (props: IconProps) => (
  <Icon width="21px" height="20px" viewBox="0 0 21 20" {...props}>
    <path d="M5.87345 9.16666v1.66664h8.33335V9.16666H5.87345Zm4.16665-7.5C5.44012 1.66666 1.70679 5.4 1.70679 10s3.73333 8.3333 8.33331 8.3333c4.6 0 8.3334-3.7333 8.3334-8.3333s-3.7334-8.33334-8.3334-8.33334Zm0 15.00004c-3.67498 0-6.66665-2.9917-6.66665-6.6667s2.99167-6.66667 6.66665-6.66667c3.675 0 6.6667 2.99167 6.6667 6.66667s-2.9917 6.6667-6.6667 6.6667Z" />
  </Icon>
);

export default memo(CircleMinusIcon);
